import { useEffect } from "react";

const useIntersectionObserver = (ref, options, callback, forceLoad = false) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    // Если включен forceLoad, сразу вызываем callback с true
    if (forceLoad) {
      callback(true);
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      callback(entry.isIntersecting);
    }, options);

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [ref, options, callback, forceLoad]); // Зависимость от ref и forceLoad
};

export default useIntersectionObserver;
